import { CheckCircleIcon } from '@heroicons/react/24/outline';

interface Props {
  onAnalyze?: () => void;
}

const ReadyCta = ({ onAnalyze }: Props) => {
  return (
    <section id="ready-cta" className="w-full">
      <div className="w-full bg-slate-50/90 py-20 md:py-28">
        <div className="mx-auto w-full max-w-6xl px-4 sm:px-8 md:px-12">
          <div
            className="mx-auto max-w-4xl rounded-3xl p-10 sm:p-14 md:p-16 text-center text-white shadow-2xl min-h-[380px] flex flex-col items-center justify-center"
            style={{
              backgroundImage:
                'linear-gradient(135deg, var(--color-primary), color-mix(in oklch, var(--color-primary) 65%, var(--color-accent)))'
            }}
          >
            <h2 className="text-3xl font-bold tracking-tight sm:text-4xl md:text-5xl">
              Ready to optimize your pricing?
            </h2>
            <p className="mt-4 text-base opacity-95 md:text-lg">
              Stop leaving revenue on the table and price smarter with FastBar's AI analysis.
            </p>

            <div className="mt-8 w-full">
              <button
                type="button"
                onClick={() => {
                  if (onAnalyze) onAnalyze();
                }}
                className="block w-full rounded-full bg-white px-5 py-3 text-base font-semibold text-[color:var(--color-primary)] shadow-md transition hover:bg-slate-50"
              >
                Get started—it's free
              </button>
            </div>

            <div className="mt-6 flex flex-wrap items-center justify-center gap-x-8 gap-y-2 text-xs opacity-95 sm:text-sm">
              <div className="inline-flex items-center gap-2">
                <CheckCircleIcon className="h-4 w-4" />
                <span>No signup required</span>
              </div>
              <div className="inline-flex items-center gap-2">
                <CheckCircleIcon className="h-4 w-4" />
                <span>No credit card</span>
              </div>
              <div className="inline-flex items-center gap-2">
                <CheckCircleIcon className="h-4 w-4" />
                <span>No hidden fees</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReadyCta;
